<template>
  <div id="agMaxConn">
    <div class="agInputGroup agInputGroupCentered">
      <label>Auth Type:</label>
      <b-form-select
        v-model="connection.authType"
        :disabled="isReadonly"
        :options="authTypes"
        style="width:200px;">
      </b-form-select>
    </div>
    <div class="agInputGroup">
      <label>Object Structures:</label>
      <multiselect id="os2" v-model="connection.datasets" :options="osOptions"  :multiple="true" label="name" track-by="name"
        :close-on-select="false" :clear-on-select="false" :preserve-search="true" :searchable="true" :loading="isLoading"
        :show-no-results="false" placeholder="Select Object Structures" @search-change="asyncFind" >
        <span slot="noResult">No Object Structures found</span>
      </multiselect>
    </div>
  </div>
</template>


<script>
// components
import Multiselect from 'vue-multiselect'
// server
import Server from '../../server'
// modules

export default {
  name: "ag-max-conn",
  components: {
    Multiselect
  },
  props: {
    isReadonly: Boolean,
    connection: Object,
  },

  data() {
    return {
        isLoading: false,
        authTypes: [
            { value: "maxauth", text: "MAXAUTH" },
            { value: "basic", text: "Basic" },
            { value: "form", text: "Form" },
        ],
        osOptions:[]
    };
  },

  computed: {

  },

  methods: {
    limitText (count) {
      return `and ${count} other Object Structures`
    },
    asyncFind (query) {
      if(query.length > 1){
        this.isLoading = true;
        let body = {connection: this.connection, osString: query}
        Server.post("getMaxObjectStructures", body).promise.then((osList) => {
          this.isLoading = false;
          if(osList.data.success){
            this.osOptions = osList.data.os;
          }
          else {
            this.osOptions = []
          }
        })
      }
      else {
        this.osOptions = []
      }
    },
    clearAll(){
      this.connection.datasets = []
    },
    // UI Events

    // other

    reset() {
      
    },

    prepareForSave() {
    },

  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lange="css">
  .agObjectStructure-fieldSearch {
    width: 200px;
  }
</style>


// WEBPACK FOOTER //
// src/components/connection/MaxConnection.vue